import React from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const Hex = (props) => (
  <SvgIcon {...props} viewBox={"0 0 326 333"}>
    <g stroke="none" strokeWidth="1">
      <g transform="translate(-1042.000000, -35.000000)">
        <path d="M1225.03103,366.542565 L1092.43329,323.906455 C1082.11129,320.58739 1074.34459,312.014205 1072.05756,301.416262 L1042.68319,165.263664 C1040.397,154.665721 1043.93734,143.652574 1051.97315,136.372842 L1155.19652,42.8580626 C1163.23062,35.5783309 1174.53937,33.1383691 1184.86136,36.4574347 L1317.4591,79.094399 C1327.78195,82.4126102 1335.54779,90.9866494 1337.83483,101.584592 L1367.2092,237.736336 C1369.49709,248.334279 1365.95505,259.347426 1357.91924,266.627158 L1254.69758,360.141937 C1246.66091,367.421669 1235.35302,369.861631 1225.03103,366.542565"></path>
      </g>
    </g>
  </SvgIcon>
);

export const Close = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48" width="48" height="48">
    <g>
      <g id="svg_1">
        <g id="svg_2">
          <g id="svg_3">
            <path d="m0,0l48,48" strokeWidth="2" id="svg_4" />
            <path d="m0,48l48,-48" strokeWidth="2" id="svg_5" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CloseWhite = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48" width="48" height="48">
    <g>
      <g id="svg_1">
        <g id="svg_2">
          <g id="svg_3">
            <path d="m0,0l48,48" strokeWidth="2" id="svg_4" />
            <path d="m0,48l48,-48" strokeWidth="2" id="svg_5" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Chat = (props) => (
  <SvgIcon {...props} viewBox={"0 0 34 27"}>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-1272.000000, -38.000000)">
        <g transform="translate(1268.000000, 36.000000)">
          <g transform="translate(0.000000, 1.000000)">
            <path d="M25.3690852,7.50157729 C25.3690852,7.40694006 25.3312303,7.36908517 25.2365931,7.36908517 L6.82018927,7.36908517 C6.78233438,7.36908517 6.7444795,7.3785489 6.71608833,7.39747634 C6.68769716,7.42586751 6.68769716,7.4637224 6.68769716,7.50157729 L6.68769716,20.7602524 C6.68769716,20.8539432 6.72555205,20.8917981 6.82018927,20.8917981 L9.76340694,20.8917981 C10.5015773,20.8917981 11.1072555,21.4880126 11.1072555,22.2356467 L11.1072555,23.9675079 L14.8454259,21.1577287 C15.0820189,20.9873817 15.3659306,20.8917981 15.6498423,20.8917981 L15.659306,20.8917981 L25.2365931,20.8917981 C25.3312303,20.8917981 25.3690852,20.8539432 25.3690852,20.7602524 L25.3690852,7.50157729 Z M37.6246057,3.82018927 L37.6246057,17.0788644 C37.6246057,18.6309148 36.3659306,19.8895899 34.8138801,19.8895899 L33.2050473,19.8895899 L33.2050473,22.9652997 C33.2050473,23.4858044 32.9211356,23.9495268 32.466877,24.1766562 C32.0126183,24.4028391 31.4542587,24.3470032 31.0567823,24.0432177 L27.8958991,21.6772871 C27.4984227,22.7949527 26.4384858,23.5700315 25.2365931,23.5700315 L16.1135647,23.5700315 L10.5772871,27.7255521 C10.340694,27.9053628 10.0473186,28 9.76340694,28 C9.55520505,28 9.35646688,27.951735 9.16719243,27.8580442 C8.70347003,27.6309148 8.41955836,27.1662461 8.41955836,26.6561514 L8.41955836,23.5700315 L6.82018927,23.5700315 C5.2681388,23.5700315 4,22.3113565 4,20.7602524 L4,7.50157729 C4,5.94952681 5.2681388,4.68138801 6.82018927,4.68138801 L13.5772871,4.68138801 L13.5772871,3.82018927 C13.5772871,2.2681388 14.8454259,1 16.3974763,1 L34.8138801,1 C36.3659306,1 37.6246057,2.2681388 37.6246057,3.82018927 L37.6246057,3.82018927 Z M10.8706625,12.659306 C10.0567823,12.659306 9.39432177,13.3123028 9.39432177,14.126183 C9.39432177,14.9400631 10.0567823,15.6025237 10.8706625,15.6025237 C11.6845426,15.6025237 12.3470032,14.9400631 12.3470032,14.126183 C12.3470032,13.3123028 11.6845426,12.659306 10.8706625,12.659306 L10.8706625,12.659306 Z M16.0283912,12.659306 C15.214511,12.659306 14.5520505,13.3123028 14.5520505,14.126183 C14.5520505,14.9400631 15.214511,15.6025237 16.0283912,15.6025237 C16.8422713,15.6025237 17.4952681,14.9400631 17.4952681,14.126183 C17.4952681,13.3123028 16.8422713,12.659306 16.0283912,12.659306 L16.0283912,12.659306 Z M22.6529968,14.126183 C22.6529968,14.9400631 22,15.6025237 21.1861199,15.6025237 C20.3722397,15.6025237 19.7097792,14.9400631 19.7097792,14.126183 C19.7097792,13.3123028 20.3722397,12.659306 21.1861199,12.659306 C22,12.659306 22.6529968,13.3123028 22.6529968,14.126183 L22.6529968,14.126183 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);
